/**
 * Header Component
 * Top navigation bar
 */

import { HTMLAttributes, forwardRef } from 'react'
import { clsx } from 'clsx'
import { BookOpen } from 'lucide-react'

export interface HeaderProps extends HTMLAttributes<HTMLElement> {
  title?: string
}

export const Header = forwardRef<HTMLElement, HeaderProps>(
  ({ title = 'Ebook Genius', className, children, ...props }, ref) => {
    return (
      <header
        ref={ref}
        className={clsx(
          'bg-white border-b border-gray-200 px-6 py-4',
          'flex items-center justify-between',
          className,
        )}
        {...props}
      >
        <div className="flex items-center gap-3">
          <BookOpen className="h-6 w-6 text-primary-600" />
          <h1 className="text-xl font-bold text-gray-900">{title}</h1>
        </div>
        {children}
      </header>
    )
  },
)

Header.displayName = 'Header'
